(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["istemeli-rozet-yonetimi"] && !Shopify.designMode) return;
  try {
    
(() => {
  const TAG = 'istemeli-badge-manager';
  if (customElements.get(TAG)) return;
  const CARDS = 'product-card, .istemeli-card';
  const OWN = '[data-ib-owned]';
  const FLASH_OWN = '[data-ib-flash-owned]';
  const mobileViewport = window.matchMedia('(max-width: 749px)');
  let timer = null;
  let watching = false;

  function schedule() {
    if (timer !== null) return;
    timer = setTimeout(() => { timer = null; render(); }, 60);
  }

  function handleOf(card) {
    const link = card.querySelector('a.istemeli-card__media[href*="/products/"], a.product-card__link[href*="/products/"], a.istemeli-card__title[href*="/products/"], a[href*="/products/"]');
    return handleFromLink(link);
  }

  function handleFromLink(link) {
    if (!link) return '';
    try {
      const path = new URL(link.getAttribute('href'), location.origin).pathname;
      const match = path.match(/\/products\/([^/]+)/);
      return match ? decodeURIComponent(match[1]) : '';
    } catch (_) { return ''; }
  }

  function badgeHost(card) {
    return card.querySelector('.istemeli-card__media, .card-gallery, .product-card__media, .product-card__image-wrapper, .product-card__image, .media, slideshow-slide') || null;
  }

  function linkedCard(link) {
    return link.closest('product-card, .istemeli-card, article, li, .swiper-slide, .splide__slide, .grid__item, .product-item, .card, [class*="product"], [class*="urun"]');
  }

  function linkedHost(link, card) {
    const image = link.querySelector('img');
    return badgeHost(card || link) || (image && image.parentElement) || link;
  }

  function number(value, fallback, min, max) {
    const n = Number(value);
    return Number.isFinite(n) ? Math.max(min, Math.min(max, n)) : fallback;
  }

  function removeBadge(badge) {
    const host = badge.parentElement;
    badge.remove();
    if (host && !host.querySelector(OWN)) host.classList.remove('ib-badge-host');
  }

  function activeFlashRules(managers, now = Date.now()) {
    const flashes = new Map();
    managers.forEach(manager => {
      manager.querySelectorAll('[data-ib-flash]').forEach(node => {
        const start = Date.parse(node.dataset.start || '');
        const end = Date.parse(node.dataset.end || '');
        const handle = node.dataset.handle || '';
        if (!handle || !Number.isFinite(start) || !Number.isFinite(end) || now < start || now >= end) return;
        if (!flashes.has(handle)) flashes.set(handle, {
          image: node.dataset.image,
          label: node.dataset.label || 'Flaş İndirimler',
          manager,
          start,
          end,
          price: Number(node.dataset.price)
        });
      });
    });
    return flashes;
  }

  function timeParts(end) {
    const remaining = Math.max(0, end - Date.now());
    const totalSeconds = Math.floor(remaining / 1000);
    return {
      hours: Math.floor(totalSeconds / 3600),
      minutes: Math.floor((totalSeconds % 3600) / 60),
      seconds: totalSeconds % 60
    };
  }

  function two(value) { return String(value).padStart(2, '0'); }

  function cardTimer(host, rule) {
    let bar = Array.from(host.children).find(child => child.matches('[data-ib-flash-owned="card"]'));
    if (!bar) {
      bar = document.createElement('div');
      bar.dataset.ibFlashOwned = 'card';
      bar.className = 'ib-flash-card-timer';
      bar.setAttribute('aria-label', 'Flaş fiyat için kalan süre');
      bar.innerHTML = '<span class="ib-flash-card-timer__bolt" aria-hidden="true">⚡</span><span data-ib-flash-clock></span>';
      host.append(bar);
    }
    const parts = timeParts(rule.end);
    bar.querySelector('[data-ib-flash-clock]').textContent = two(parts.hours) + ':' + two(parts.minutes) + ':' + two(parts.seconds);
    return bar;
  }

  function detailTimer(root, rule) {
    let bar = root.querySelector('[data-ib-flash-owned="detail"]');
    if (!bar) {
      const title = root.querySelector('h1, [data-testid="product-title"], .product-title');
      if (!title || !title.parentElement) return null;
      bar = document.createElement('div');
      bar.dataset.ibFlashOwned = 'detail';
      bar.className = 'ib-flash-detail-timer';
      bar.setAttribute('aria-label', 'Flaş ürünler geri sayımı');
      bar.innerHTML = '<span class="ib-flash-detail-timer__title"><span class="ib-flash-detail-timer__bolt" aria-hidden="true">⚡</span>Flaş Ürünler</span><span class="ib-flash-detail-timer__time"><span class="ib-flash-detail-timer__unit" data-ib-hours></span><span class="ib-flash-detail-timer__colon">:</span><span class="ib-flash-detail-timer__unit" data-ib-minutes></span><span class="ib-flash-detail-timer__colon">:</span><span class="ib-flash-detail-timer__unit" data-ib-seconds></span></span>';
      title.parentElement.insertBefore(bar, title);
    }
    const parts = timeParts(rule.end);
    bar.querySelector('[data-ib-hours]').textContent = two(parts.hours);
    bar.querySelector('[data-ib-minutes]').textContent = two(parts.minutes);
    bar.querySelector('[data-ib-seconds]').textContent = two(parts.seconds);
    return bar;
  }

  function placeBadge(host, rule, manager, productPage = false) {
    let badge = Array.from(host.children).find(child => child.matches(OWN));
    if (!badge) {
      badge = document.createElement('div');
      badge.dataset.ibOwned = 'true';
      badge.className = 'ib-product-badge';
      badge.setAttribute('role', 'img');
      const img = document.createElement('img');
      img.alt = '';
      img.width = 160;
      img.height = 160;
      img.decoding = 'async';
      img.addEventListener('error', () => { img.style.setProperty('display', 'none', 'important'); });
      img.addEventListener('load', () => { img.style.removeProperty('display'); });
      badge.append(img);
      host.append(badge);
    }
    host.classList.add('ib-badge-host');
    if (!productPage) {
      host.style.setProperty('overflow', 'hidden', 'important');
      host.style.setProperty('isolation', 'isolate', 'important');
      host.style.setProperty('z-index', '0', 'important');
    } else {
      host.style.setProperty('overflow', 'visible', 'important');
    }
    const img = badge.querySelector('img');
    if (img.getAttribute('src') !== rule.image) img.setAttribute('src', rule.image);
    badge.setAttribute('aria-label', rule.label);
    badge.dataset.ibPlacement = productPage ? 'product' : 'card';
    const desktop = productPage ? number(manager.dataset.productDesktop, 120, 60, 160) : number(manager.dataset.desktop, 80, 40, 120);
    const mobile = productPage ? number(manager.dataset.productMobile, 84, 40, 120) : number(manager.dataset.mobile, 64, 40, 100);
    badge.style.setProperty('--ib-desktop', desktop + 'px');
    badge.style.setProperty('--ib-mobile', mobile + 'px');
    badge.style.setProperty('--ib-offset', number(manager.dataset.offset, 8, 0, 24) + 'px');
    const size = (mobileViewport.matches ? mobile : desktop) + 'px';
    const offset = number(manager.dataset.offset, 8, 0, 24) + 'px';
    const overlayStyle = {
      position: 'absolute', display: 'block', top: offset, left: offset,
      right: 'auto', bottom: 'auto', width: size, height: size,
      'min-width': '0', 'min-height': '0', 'max-width': 'calc(100% - 16px)',
      'max-height': 'none', margin: '0', padding: '0', border: '0',
      background: 'transparent', 'box-shadow': 'none',
      transform: 'none', 'pointer-events': 'none', 'z-index': '2',
      'box-sizing': 'border-box', 'line-height': '0', overflow: 'visible'
    };
    Object.entries(overlayStyle).forEach(([key, value]) => badge.style.setProperty(key, value, 'important'));
    const imageStyle = {
      position: 'static', display: 'block', width: '100%', height: '100%',
      'min-width': '0', 'min-height': '0', 'max-width': '100%', 'max-height': '100%',
      margin: '0', padding: '0', border: '0', transform: 'none',
      'object-fit': 'contain', 'object-position': 'center', 'aspect-ratio': '1',
      background: 'transparent', 'box-shadow': 'none'
    };
    Object.entries(imageStyle).forEach(([key, value]) => img.style.setProperty(key, value, 'important'));
    return badge;
  }

  function productHandle(manager, root) {
    // Prefer the displayed product after a variant/combined-product re-render.
    const component = root.querySelector('product-component[view-event-payload]');
    if (component) {
      try {
        const payload = JSON.parse(component.getAttribute('view-event-payload'));
        if (payload.product && payload.product.handle) return payload.product.handle;
      } catch (_) { /* Fall back to the server-rendered product handle. */ }
    }
    return manager.dataset.productHandle || '';
  }


  function renderBadgeContent(managers) {
    const firstManager = managers[0] || null;
    document.querySelectorAll('[data-ib-nav-target], [data-ib-page-target]').forEach(target => {
      const isPage = target.hasAttribute('data-ib-page-target');
      const navSource = firstManager && firstManager.querySelector('template[data-ib-nav-source]');
      const pageSources = managers.map(manager => manager.querySelector('template[data-ib-page-source]')).filter(Boolean);
      const signature = isPage ? pageSources.map(source => source.innerHTML).join('') : (navSource ? navSource.innerHTML : '');
      if (target._ibSignature === signature) return;
      target._ibSignature = signature;
      if (!signature) {
        target.replaceChildren();
        if (isPage) {
          const message = document.createElement('p');
          message.textContent = 'Şu anda bu rozete ait ürün bulunmuyor.';
          target.append(message);
        }
        return;
      }
      if (!isPage) {
        target.replaceChildren(navSource.content.cloneNode(true));
        return;
      }
      target.replaceChildren();
      let toolbar = null;
      let grid = null;
      let more = null;
      const seenCards = new Set();
      pageSources.forEach(source => {
        const fragment = source.content.cloneNode(true);
        const sourceGrid = fragment.querySelector('[data-ib-grid]');
        const sourceCards = sourceGrid ? [...sourceGrid.querySelectorAll('[data-ib-list-card]')] : [];
        if (sourceCards.length) {
          sourceCards.forEach(card => {
            const link = card.querySelector('a[href]');
            const key = link ? link.getAttribute('href') : '';
            if (key && seenCards.has(key)) {
              card.dataset.ibSkip = 'true';
              card.remove();
            }
            if (key) seenCards.add(key);
          });
          if (!toolbar) {
            toolbar = fragment.querySelector('.ib-list-toolbar');
            grid = fragment.querySelector('[data-ib-grid]');
            more = fragment.querySelector('[data-ib-more]');
            target.append(toolbar, grid);
            if (more) target.append(more);
          } else {
            sourceCards.forEach(card => { if (card.dataset.ibSkip !== 'true') grid.append(card); });
          }
        } else if (!toolbar && !target.childElementCount) {
          target.append(fragment);
        }
      });
      if (isPage) {
        const cards = [...target.querySelectorAll('[data-ib-list-card]')];
        const count = target.querySelector('[data-ib-count]');
        const more = target.querySelector('[data-ib-more]');
        let shown = 24;
        function update() {
          cards.forEach((card, i) => { card.hidden = i >= shown; });
          if (more) more.hidden = shown >= cards.length;
          if (count) count.textContent = cards.length + ' ürün';
        }
        if (more) more.addEventListener('click', () => {
          const firstNew = cards[shown];
          shown += 24; update();
          if (firstNew) firstNew.querySelector('a').focus();
        });
        const sort = target.querySelector('[data-ib-sort]');
        if (sort) sort.addEventListener('change', () => {
          const sorted = [...cards].sort((a, b) => sort.value === 'price-asc' ? Number(a.dataset.price) - Number(b.dataset.price) : sort.value === 'price-desc' ? Number(b.dataset.price) - Number(a.dataset.price) : Number(a.dataset.index) - Number(b.dataset.index));
          cards.splice(0, cards.length, ...sorted);
          const grid = target.querySelector('[data-ib-grid]');
          cards.forEach(card => grid.append(card)); shown = 24; update();
        });
        update();
      }
    });
  }

  function render() {
    const managers = [...document.querySelectorAll(TAG)].filter(manager => manager.dataset.enabled === 'true');
    const rules = new Map();
    managers.forEach(manager => {
      manager.querySelectorAll('[data-ib-rule]').forEach(rule => {
        if (!rule.dataset.image) return;
        (rule.dataset.handles || '').split(',').filter(Boolean).forEach(handle => {
          if (!rules.has(handle)) rules.set(handle, { image: rule.dataset.image, label: rule.dataset.label, manager });
        });
      });
    });
    const flashRules = activeFlashRules(managers);
    flashRules.forEach((rule, handle) => { rules.set(handle, rule); });
    renderBadgeContent(managers);
    document.querySelectorAll(OWN).forEach(removeBadge);
    document.querySelectorAll(FLASH_OWN).forEach(node => node.remove());
    const kept = new Set();
    document.querySelectorAll(CARDS).forEach(card => {
      if (card.parentElement && card.parentElement.closest(CARDS)) return;
      const rule = rules.get(handleOf(card));
      const host = badgeHost(card);
      if (!rule || !host) return;
      kept.add(placeBadge(host, rule, rule.manager));
      if (flashRules.get(handleOf(card)) === rule) cardTimer(host, rule);
    });
    const handledLinkedCards = new WeakSet();
    document.querySelectorAll('a[href*="/products/"]').forEach(link => {
      if (link.closest(OWN)) return;
      if (link.closest('[data-testid="product-information"], dialog, quick-add-dialog, [role="dialog"]')) return;
      // product-card ve .istemeli-card öğeleri yukarıdaki ana döngüde işlendi.
      // Mobil kartta görsel ve başlık ayrı bağlantılar olduğundan bunları tekrar
      // işlemek aynı karta ikinci bir sayaç ekleyebilir.
      if (link.closest(CARDS)) return;
      const rule = rules.get(handleFromLink(link));
      if (!rule) return;
      const card = linkedCard(link);
      if (card && handledLinkedCards.has(card)) return;
      const host = linkedHost(link, card);
      if (!host) return;
      if (card) handledLinkedCards.add(card);
      kept.add(placeBadge(host, rule, rule.manager));
      if (flashRules.get(handleFromLink(link)) === rule) cardTimer(host, rule);
    });
    // Main buybox gallery only: never zoom dialogs, thumbnails or quick-view modals.
    const productManager = managers.find(manager => manager.dataset.showProduct !== 'false' && manager.dataset.productHandle);
    if (productManager) {
      document.querySelectorAll('[data-testid="product-information"]').forEach(root => {
        if (root.closest('dialog, quick-add-dialog, [role="dialog"]')) return;
        const rule = rules.get(productHandle(productManager, root));
        const media = root.querySelector('.product-information__media');
        if (!rule || !media) return;
        // Do not insert a badge image inside media-gallery/slideshow-container.
        // Gallery scripts and mobile styles may otherwise treat it as media.
        kept.add(placeBadge(media, rule, rule.manager, true));
        if (flashRules.get(productHandle(productManager, root)) === rule) detailTimer(root, rule);
      });
    }
    document.querySelectorAll(OWN).forEach(badge => { if (!kept.has(badge)) removeBadge(badge); });
    if (!document.querySelector(TAG)) { observer.disconnect(); watching = false; }
  }

  const observer = new MutationObserver(records => {
    const changed = records.some(record => {
      if (record.target.nodeType === 1 && record.target.closest(OWN + ', ' + FLASH_OWN)) return false;
      if (record.type === 'attributes') return Boolean(record.target.closest(CARDS + ', [data-testid="product-information"], a[href*="/products/"]'));
      return [...record.addedNodes, ...record.removedNodes].some(node =>
        node.nodeType === 1 && !node.matches(OWN + ', ' + FLASH_OWN)
      );
    });
    if (changed) schedule();
  });

  class BadgeManager extends HTMLElement {
    connectedCallback() {
      if (!watching) {
        observer.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['href', 'view-event-payload'] });
        watching = true;
      }
      schedule();
    }
    disconnectedCallback() { schedule(); }
  }
  customElements.define(TAG, BadgeManager);
  mobileViewport.addEventListener('change', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('shopify:section:unload', schedule);
  document.addEventListener('shopify:section:reorder', schedule);
  document.addEventListener('DOMContentLoaded', schedule, { once: true });
  setInterval(schedule, 1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
